// imports
import { isEmailValid, isPasswordValid, hideFormSubmitError } from "./utils";
import { LOGIN_FORM, SIGN_UP_FORM, SIGN_UP_OTP_FORM, LOGIN_FORM_CONTROL_FIELD_LIST, SIGN_UP_FORM_CONTROL_FIELD_LIST, SIGN_UP_OTP_FORM_CONTROL_FIELD_LIST, FORM_SUBMIT_MESSAGE_TEXT_ID, FORM_CONTROL, FORM_CONTROL_FIELD, FORM_CONTROL_ERROR_CLASS, FORM_FIELD_ERROR_MESSAGE, APP_EVENT_MESSAGE, FORGOT_PASSWORD_FORM, RESET_PASSWORD_FORM, FORGOT_PASSWORD_FORM_CONTROL_FIELD_LIST, RESET_PASSWORD_FORM_CONTROL_FIELD_LIST, FORM_CONTROL_FIELDS } from "./constants";

export const validateForm = (form, field) => {
    try {
        if (form !== LOGIN_FORM && form !== SIGN_UP_FORM && !form === SIGN_UP_OTP_FORM && form !== FORGOT_PASSWORD_FORM && form !== RESET_PASSWORD_FORM) {
            throw 'validateForm(): form value as first argument is undefined or invalid';
        }
        if (form === LOGIN_FORM && !LOGIN_FORM_CONTROL_FIELD_LIST.includes(field)) {
            throw 'validateForm(): form field value as second argument is undefined or invalid';
        }
        if (form === SIGN_UP_FORM && !SIGN_UP_FORM_CONTROL_FIELD_LIST.includes(field)) {
            throw 'validateForm(): form field value as second argument is undefined or invalid';
        }
        if (form === SIGN_UP_OTP_FORM && !SIGN_UP_OTP_FORM_CONTROL_FIELD_LIST.includes(field)) {
            throw 'validateForm(): form field value as second argument is undefined or invalid';
        }
        if (form === FORGOT_PASSWORD_FORM && !FORGOT_PASSWORD_FORM_CONTROL_FIELD_LIST.includes(field)) {
            throw 'validateForm(): form field value as second argument is undefined or invalid';
        }
        if (form === RESET_PASSWORD_FORM && !RESET_PASSWORD_FORM_CONTROL_FIELD_LIST.includes(field)) {
            throw 'validateForm(): form field value as second argument is undefined or invalid';
        }

        if (document.getElementById(`${FORM_SUBMIT_MESSAGE_TEXT_ID[form]}`)) {
            hideFormSubmitError(form);
        }

        const validationStatus = {
            firstName: true,
            lastName: true,
            email: true,
            password: true,
            confirmPassword: true,
            mobile: true,
            emailOtp: true
        };

        // email
        let email = null;
        let emailError = null;
        // password
        let password = null;
        let passwordError = null;
        // confirm password
        let confirmPassword = null;
        let confirmPasswordError = null;
        // first name
        let firstName = null;
        let firstNameError = null;
        // last name
        let lastName = null;
        let lastNameError = null;
        // mobile
        let mobile = null;
        let mobileError = null;
        // email otp
        let emailOtp = null;
        let emailOtpError = null;

        if (form === LOGIN_FORM || form === SIGN_UP_FORM) {
            email = document.querySelector(`#${FORM_CONTROL[form].email.id}`);
            emailError = document.querySelector(`#${FORM_CONTROL[form].emailError.id}`);

            password = document.querySelector(`#${FORM_CONTROL[form].password.id}`);
            passwordError = document.querySelector(`#${FORM_CONTROL[form].passwordError.id}`);
        }

        if (form === SIGN_UP_FORM) {
            confirmPassword = document.querySelector(`#${FORM_CONTROL[form].confirmPassword.id}`);
            confirmPasswordError = document.querySelector(`#${FORM_CONTROL[form].confirmPasswordError.id}`);

            firstName = document.querySelector(`#${FORM_CONTROL[form].firstName.id}`);
            firstNameError = document.querySelector(`#${FORM_CONTROL[form].firstNameError.id}`);

            lastName = document.querySelector(`#${FORM_CONTROL[form].lastName.id}`);
            lastNameError = document.querySelector(`#${FORM_CONTROL[form].lastNameError.id}`);
        }

        if (form === SIGN_UP_OTP_FORM) {
            emailOtp = document.querySelector(`#${FORM_CONTROL[form].emailOtp.id}`);
            emailOtpError = document.querySelector(`#${FORM_CONTROL[form].emailOtpError.id}`);
        }

        if (form === FORGOT_PASSWORD_FORM) {
            email = document.querySelector(`#${FORM_CONTROL[form].email.id}`);
            emailError = document.querySelector(`#${FORM_CONTROL[form].emailError.id}`);
        }

        if (form === RESET_PASSWORD_FORM) {
            password = document.querySelector(`#${FORM_CONTROL[form].password.id}`);
            passwordError = document.querySelector(`#${FORM_CONTROL[form].passwordError.id}`);

            confirmPassword = document.querySelector(`#${FORM_CONTROL[form].confirmPassword.id}`);
            confirmPasswordError = document.querySelector(`#${FORM_CONTROL[form].confirmPasswordError.id}`);

            emailOtp = document.querySelector(`#${FORM_CONTROL[form].emailOtp.id}`);
            emailOtpError = document.querySelector(`#${FORM_CONTROL[form].emailOtpError.id}`);
        }

        const addError = (field, errorMessage) => {
            switch (field) {
                case FORM_CONTROL_FIELD.email:
                    email.classList.add(FORM_CONTROL_ERROR_CLASS.input);
                    emailError.innerText = errorMessage;
                    validationStatus.email = false;
                    break;
                case FORM_CONTROL_FIELD.password:
                    password.classList.add(FORM_CONTROL_ERROR_CLASS.input);
                    passwordError.innerText = errorMessage;
                    validationStatus.password = false;
                    break;
                case FORM_CONTROL_FIELD.confirmPassword:
                    confirmPassword.classList.add(FORM_CONTROL_ERROR_CLASS.input);
                    confirmPasswordError.innerText = errorMessage;
                    validationStatus.confirmPassword = false;
                    break;
                case FORM_CONTROL_FIELD.firstName:
                    firstName.classList.add(FORM_CONTROL_ERROR_CLASS.input);
                    firstNameError.innerText = errorMessage;
                    validationStatus.firstName = false;
                    break;
                case FORM_CONTROL_FIELD.lastName:
                    lastName.classList.add(FORM_CONTROL_ERROR_CLASS.input);
                    lastNameError.innerText = errorMessage;
                    validationStatus.lastName = false;
                    break;
                case FORM_CONTROL_FIELD.emailOtp:
                    emailOtp.classList.add(FORM_CONTROL_ERROR_CLASS.input);
                    emailOtpError.innerText = errorMessage;
                    validationStatus.emailOtp = false;
                    break;
            }
        }

        const removeError = () => {
            switch (field) {
                case FORM_CONTROL_FIELD.email:
                    email.classList.remove(FORM_CONTROL_ERROR_CLASS.input);
                    emailError.innerText = FORM_FIELD_ERROR_MESSAGE.email.valid;
                    validationStatus.email = true;
                    break;
                case FORM_CONTROL_FIELD.password:
                    password.classList.remove(FORM_CONTROL_ERROR_CLASS.input);
                    passwordError.innerText = FORM_FIELD_ERROR_MESSAGE.password.valid;
                    validationStatus.password = true;
                    break;
                case FORM_CONTROL_FIELD.confirmPassword:
                    confirmPassword.classList.remove(FORM_CONTROL_ERROR_CLASS.input);
                    confirmPasswordError.innerText = FORM_FIELD_ERROR_MESSAGE.confirmPassword.valid;
                    validationStatus.confirmPassword = true;
                    break;
                case FORM_CONTROL_FIELD.firstName:
                    firstName.classList.remove(FORM_CONTROL_ERROR_CLASS.input);
                    firstNameError.innerText = FORM_FIELD_ERROR_MESSAGE.firstName.valid;
                    validationStatus.firstName = true;
                    break;
                case FORM_CONTROL_FIELD.lastName:
                    lastName.classList.remove(FORM_CONTROL_ERROR_CLASS.input);
                    lastNameError.innerText = FORM_FIELD_ERROR_MESSAGE.lastName.valid;
                    validationStatus.lastName = true;
                    break;
                case FORM_CONTROL_FIELD.emailOtp:
                    emailOtp.classList.remove(FORM_CONTROL_ERROR_CLASS.input);
                    emailOtpError.innerText = FORM_FIELD_ERROR_MESSAGE.emailOtp.valid;
                    validationStatus.emailOtp = true;
                    break;
            }
        }

        const updateEmailControl = () => {
            if (email.value.length > 0) {
                isEmailValid(email.value) ? removeError(FORM_CONTROL_FIELD.email) : addError(FORM_CONTROL_FIELD.email, FORM_FIELD_ERROR_MESSAGE.email.invalid);
            } else {
                addError(FORM_CONTROL_FIELD.email, FORM_FIELD_ERROR_MESSAGE.email.required);
            }
        }

        const updatePasswordControl = () => {
            if (password.value.length > 0) {
                form === SIGN_UP_FORM || form === RESET_PASSWORD_FORM ?
                    isPasswordValid(password.value) ? removeError(FORM_CONTROL_FIELD.password) : addError(FORM_CONTROL_FIELD.password, FORM_FIELD_ERROR_MESSAGE.password.invalid) :
                    removeError(FORM_CONTROL_FIELD.password);
            } else {
                addError(FORM_CONTROL_FIELD.password, FORM_FIELD_ERROR_MESSAGE.password.required);
            }

            // if (confirmPassword && confirmPassword.value.length !== 0) {
            //     updateConfirmPasswordControl();
            // }
        }

        const updateConfirmPasswordControl = () => {
            if (confirmPassword.value.length > 0 && password.value.length === 0) {
                addError(FORM_CONTROL_FIELD.confirmPassword, FORM_FIELD_ERROR_MESSAGE.confirmPassword.passwordNotFilled);
            } else if (confirmPassword.value.length > 0 && password.value.length > 0) {
                if (isPasswordValid(password.value)) {
                    confirmPassword.value === password.value ? removeError(FORM_CONTROL_FIELD.confirmPassword) : addError(FORM_CONTROL_FIELD.confirmPassword, FORM_FIELD_ERROR_MESSAGE.confirmPassword.invalid);
                } else {
                    addError(FORM_CONTROL_FIELD.confirmPassword, FORM_FIELD_ERROR_MESSAGE.confirmPassword.passwordIsInvalid);
                }
            } else {
                addError(FORM_CONTROL_FIELD.confirmPassword, FORM_FIELD_ERROR_MESSAGE.confirmPassword.required);
            }
        }

        const updateFirstNameControl = () => {
            firstName.value.length > 0 ? removeError(FORM_CONTROL_FIELD.firstName) : addError(FORM_CONTROL_FIELD.firstName, FORM_FIELD_ERROR_MESSAGE.firstName.required);
        }

        const updateLastNameControl = () => {
            lastName.value.length > 0 ? removeError(FORM_CONTROL_FIELD.lastName) : addError(FORM_CONTROL_FIELD.lastName, FORM_FIELD_ERROR_MESSAGE.lastName.required);
        }

        const updateEmailOtpControl = () => {
            emailOtp.value.length > 0 ? removeError(FORM_CONTROL_FIELD.emailOtp) : addError(FORM_CONTROL_FIELD.emailOtp, FORM_FIELD_ERROR_MESSAGE.emailOtp.required);
        }

        switch (field) {
            case FORM_CONTROL_FIELD.email:
                updateEmailControl();
                break;
            case FORM_CONTROL_FIELD.password:
                updatePasswordControl();
                break;
            case FORM_CONTROL_FIELD.confirmPassword:
                updateConfirmPasswordControl();
                break;
            case FORM_CONTROL_FIELD.firstName:
                updateFirstNameControl();
                break;
            case FORM_CONTROL_FIELD.lastName:
                updateLastNameControl();
                break;
            case FORM_CONTROL_FIELD.emailOtp:
                updateEmailOtpControl();
                break;
            case FORM_CONTROL_FIELD.all:
                if (form === LOGIN_FORM || form === SIGN_UP_FORM) {
                    updateEmailControl();
                    updatePasswordControl();
                }
                if (form === SIGN_UP_FORM) {
                    updateConfirmPasswordControl();
                    updateFirstNameControl();
                    updateLastNameControl();
                }
                if (form === SIGN_UP_OTP_FORM) {
                    updateEmailOtpControl();
                }
                if (form === FORGOT_PASSWORD_FORM) {
                    updateEmailControl();
                }
                if (form === RESET_PASSWORD_FORM) {
                    updatePasswordControl();
                    updateConfirmPasswordControl();
                    updateEmailOtpControl();
                }
        }

        // returning form validation status
        return !Object.values(validationStatus).some(value => value === false);
    } catch (err) {
        console.error(err);
    }
};

export const getAppEventData = (event, payload) => {
    return { app: { event: APP_EVENT_MESSAGE[event].event, message: APP_EVENT_MESSAGE[event].message }, user: payload };
};

export const resetForm = (form) => {
    try {
        // reset input
        FORM_CONTROL_FIELDS[form].input.forEach(field => {
            const elem = document.querySelector(`#${FORM_CONTROL[form][field].id}`);
            if (elem) {
                elem.value = "";
            }
        });

        // reset input error
        FORM_CONTROL_FIELDS[form].error.forEach(field => {
            const elem = document.querySelector(`#${FORM_CONTROL[form][field].id}`);
            if (elem) {
                elem.innerHTML = "";
            }
        });
    } catch (err) {
        console.error(err);
    }
};

export const disableFormInputFields = (form) => {
    try {
        FORM_CONTROL_FIELDS[form].input.forEach(field => {
            const elem = document.querySelector(`#${FORM_CONTROL[form][field].id}`);
            if (elem) {
                elem.disabled = true
            }
        });
    } catch (err) {
        console.error(err);
    }
};